import React, { FC } from "react";
import MuiDialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { IconButton } from "@mui/material";
import "./style.scss";
import Dialog from "@mui/material/Dialog";
import { SignupForm } from "@Components/Signup";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

interface IjoinDialog {
    openSignup: boolean;
    handleCloseSignup: () => void;
    handlePreviousDialog: () => void;
    handleCallback: (childData: boolean) => void;
}

const JoinDialog: FC<IjoinDialog> = ({
    openSignup,
    handleCloseSignup,
    handlePreviousDialog,
    handleCallback,
}) => {
    return (
        <Dialog
            open={openSignup}
            onClose={handleCloseSignup}
            aria-labelledby="form-dialog-title"
        >
            <MuiDialogTitle sx={{ pb: 0 }}>
                <IconButton
                    aria-label="close"
                    onClick={handlePreviousDialog}
                    size="large"
                >
                    <ArrowBackIosIcon />
                </IconButton>
            </MuiDialogTitle>
            <DialogContent>
                <SignupForm parentCallback={handleCallback} />
            </DialogContent>
        </Dialog>
    );
};
export default JoinDialog;
